import { injectable } from 'inversify';
import 'reflect-metadata';
import axios from 'axios';
import { ERRORS } from '../constants/errors/error-messages.constants';
import { ApiResponse } from '../utils/api-response.utils';

@injectable()
export class MaintenanceService {
  async getMaintenanceStatus(): Promise<ApiResponse<boolean>> {
    try {
      const response = await axios.get<ApiResponse<boolean>>(
        '/api/maintenance/status'
      );
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
